import { ROLES as R } from "../core/roles";
import { everyoneBut, only, rule } from "../core/rule";

// The authenticated /auth area. `new` clients are kept out of it and use
// only the store-onboarding wizard (see onboarding.store.view).
export const appPermissions = {
  enter: "app.enter",
  // /test-ui: internal UI component showcase, in the sidebar for these roles only
  testUi: "app.testUi",
};

export const appGrants = {
  "app.enter": rule([...everyoneBut(), R.NEW]),
  "app.testUi": rule(only(R.CEO, R.CTO, R.DEVELOPER)),
};
